module.exports = __webpack_public_path__ + "img/vials.cfe0da35.svg";